export const currentUser = (state) => state.currentUser
export const accountTypes = (state) => state.accountTypes
export const defaultAccount = (state) => state.defaultAccount

export const roleTypes = (state) => state.roleTypes
export const defaultRole = (state) => state.defaultRole

export const statusTypes = (state) => state.statusTypes
export const defaultStatus = (state) => state.defaultStatus

export const defaultCountry = (state) => state.defaultCountry
